module.exports = __webpack_public_path__ + "img/phone-container-1-overlay-tablet.cfb9489a.png";